import { render, staticRenderFns } from "./permissionEdit.vue?vue&type=template&id=28417f4a"
import script from "./permissionEdit.vue?vue&type=script&lang=js"
export * from "./permissionEdit.vue?vue&type=script&lang=js"
import style0 from "./permissionEdit.vue?vue&type=style&index=0&id=28417f4a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports